import React from 'react';

import { Asterisk } from '../../assets/icons';

const RequiredIcon = () => (
  <Asterisk
    color="#ff6633"
    width={12}
    height={12}
    style={{ marginLeft: '3px' }}
  />
);

export { RequiredIcon };
